export default __webpack_public_path__ + "static/media/StormyWeather.93db38f3.png";